export default __webpack_public_path__ + "static/c10-f3289335fa68d81b63265a713a545b87.png";